import { render } from "./HcReadmit.vue?vue&type=template&id=0752ea65&ts=true"
import script from "./HcReadmit.ts?vue&type=script&lang=ts&external"
export * from "./HcReadmit.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__